import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { getEventAlarmTypes } from '../../../services/gptService';
import { eventAlarmTypesState, loadedEventAlarmTypesState } from '../../../storage/gpt';

function EventAlarmTypesProvider() {
  const setAlarmTypes = useSetRecoilState(eventAlarmTypesState);
  const setLoadedAlarmTypes = useSetRecoilState(loadedEventAlarmTypesState);

  useEffect(() => {
    const load = async () => {
      setLoadedAlarmTypes(false);
      const { alarmTypes, error } = await getEventAlarmTypes();
      if (!error && alarmTypes) {
        setAlarmTypes(alarmTypes);
      } else {
        setAlarmTypes(undefined);
      }
      setLoadedAlarmTypes(true);
    };

    load();
  }, []);

  return null;
}

export default EventAlarmTypesProvider;
